import { FaInstagram } from "react-icons/fa6";
import { IoCallOutline, IoLocationSharp, IoTime } from "react-icons/io5";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

const Footer = () => {
  return (
    <footer
      className="relative bg-[#0B1E2B] text-white w-full h-auto px-6 py-10 leading-8"
      style={{
        backgroundImage: "url('/media/footer.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay for darkening the image */}
      <div className="absolute inset-0 bg-[#0B1E2B]/80 pointer-events-none" />
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 text-lg">
          {/* Column 1 - Brand Info */}
          <div className="space-y-4 text-left justify-start">
            <h2 className="text-4xl font-bold text-orange-500">Zesty Tongue</h2>
            <p className="mt-1 text-md text-gray-400">
              Where flavor meets integrity
            </p>
            <div className="mt-4 space-y-2 text-gray-400">
              <p className="flex items-center gap-2 text-base">
                <HiOutlineOfficeBuilding size={18} style={{ color: "var(--primary)" }} />
                Zesty Tongue Foods Pvt Ltd.
              </p>
              <p className="flex items-center gap-2 text-base">
                <IoCallOutline size={18} style={{ color: "var(--primary)" }} />
                +91-96666-38552
              </p>
              <div className="flex items-start gap-2 text-base">
                <IoLocationSharp size={18} style={{ color: "var(--primary)" }} className="mt-1" />
                <address className="not-italic text-gray-400 leading-6 max-w-xs break-words">
                  Plot 121, 1st floor, Road 3<br/>
                  Kakateeyahills, Madhapur<br/>
                  Hyderabad, 500081, TG
                </address>
              </div>
              <p className="flex items-center gap-2 text-base">
                <IoTime size={18} style={{ color: "var(--primary)" }} />
                Mon-Sat: 9:00 AM - 6:00 PM
              </p>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="space-y-4 text-left justify-start">
            <h3 className="text-lg font-semibold text-white mb-2">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="/">Home</a></li>
              <li><a href="/fruit-pulp">Fruit Pulp</a></li>
              <li><a href="/marinated-chicken">Marinated Chicken</a></li>
              <li><a href="/seafood">Seafood</a></li>
              <li><a href="/brochure">Brochure</a></li>
              <li><a href="/about-us">About Us</a></li>
              <li><a href="/contact-us">Contact Us</a></li>
            </ul>
          </div>

          {/* Column 3 - Products */}
          <div className="space-y-4 text-left justify-start">
            <h3 className="text-lg font-semibold text-white mb-2">Our Products</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Premium Fruit Pulps</li>
              <li>Marinated Chicken</li>
              <li>Fresh Seafood</li>
              <li>Party Packages</li>
              <li>Bulk Orders</li>
            </ul>
          </div>

          {/* Column 4 - Social */}
          <div className="space-y-4 text-left justify-start">
            <h3 className="text-lg font-semibold text-white mb-2">Connect With Us</h3>
            <div className="flex space-x-4 text-xl text-gray-400 mb-4 items-center">
              <a href="https://www.instagram.com/thezestytongue/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2">
                <FaInstagram className="hover:text-white cursor-pointer" />
                <span className="text-base text-gray-400 hover:text-white">@thezestytongue</span>
              </a>
            </div>
            {/* Our Brands Section */}
            <div className="mt-6">
              <h4 className="text-md font-semibold text-white mb-2">Our Brands</h4>
              <div className="flex items-center space-x-4">
                <img src="/media/venlins-logo.webp" alt="Venlins Logo" className="h-16 w-auto object-contain rounded-lg" />
              </div>
            </div>
          </div>
        </div>

        {/* Certification Images */}
        <div className="mt-10 border-t border-gray-700 pt-6">
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8">
            <img src="/media/fssai-footer.webp" alt="FSSAI Certified" className="h-12 object-contain" />
            <img src="/media/iso-footer.webp" alt="ISO Certified" className="h-12 object-contain" />
            <img src="/media/haccp-footer.webp" alt="HACCP Certified" className="h-12 object-contain" />
            <img src="/media/halal-footer.webp" alt="Halal Certified" className="h-12 object-contain" />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 border-t border-gray-700 pt-4 text-center text-base text-gray-400">
          © {new Date().getFullYear()} Zesty Tongue. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
